import styled, { keyframes, css } from 'styled-components';

export const starFadeIn = keyframes`
  0% {
    opacity: 0;
    transform: scale(0);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
`;

export const diamondRotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const bottomStarStyles = css`
  .bottom-star {
    opacity: 0;
    transform-origin: center;
    animation: ${starFadeIn} 0.4s ease-out forwards;
  }

  .bottom-star-1 { animation-delay: 0.3s; }
  .bottom-star-2 { animation-delay: 0.5s; }
  .bottom-star-3 { animation-delay: 0.7s; }
  .bottom-star-4 { animation-delay: 0.9s; }
`;

export const decorativeStarStyles = css`
  .star {
    opacity: 0;
    transform-origin: center;
    animation: ${starFadeIn} 0.5s ease-out forwards;
  }

  .star-1 { animation-delay: 0.1s; }
  .star-2 { animation-delay: 0.3s; }
  .star-3 { animation-delay: 0.5s; }
`;

export const diamondStarStyles = css`
  .star {
    opacity: 0;
    transform-origin: center;
    animation: ${starFadeIn} 0.5s ease-out forwards;
  }

  ${[...Array(30)].map((_, i) => `
    .star-${i + 1} {
      animation-delay: ${0.1 + i * 0.08}s;
    }
  `).join('')}
`;

export const lightRaysStyles = css`
  .light-rays {
    transform-origin: 264.746px 217.203px;
    animation: ${diamondRotate} 15s linear infinite;
  }
`;

export const AnimatedBadgeSvg = styled.svg`
  ${bottomStarStyles}
`;

export const AnimatedGoldSvg = styled.svg`
  ${bottomStarStyles}
  ${decorativeStarStyles}
`;

export const AnimatedDiamondSvg = styled.svg`
  ${bottomStarStyles}
  ${diamondStarStyles}
  ${lightRaysStyles}
`;
